/** 基础组件, 只负责展示功能 */
import Text from './base/text'
import Image from './base/image'
import Tinymce from './base/tinymce'
import Qrcode from './base/qrcode'
import Input from './base/input'
import Progress from './base/progress'
import WaveProgress from './base/waveProgress'
import Svga from './base/svga'
import Stepper from './base/stepper'
import Swiper from './base/swiper'
/** 容器组件, 负责布局 */
import VerticalLayout from './container/verticalLayout'
import HorizontalLayout from './container/horizontalLayout'
import AbsoluteLayout from './container/absoluteLayout'
import FixedLayout from './container/fixedLayout'
import ListItemLayout from './container/listItemLayout'
/** 功能组件, 负责交互 */
import Dialog from './plus/dialog'
import CountDown from './plus/countDown'
/** 业务组件, 负责交互, 业务逻辑 */
import LuckyWheel from './business/luckyWheel'
import LuckyGrid from './business/luckyGrid'
import LuckyGridTwo from './business/luckyGridTwo'
import LuckyBtn from './business/luckyBtn'
import ActivityMarquee from './business/activityMarquee'
import Raffle from './business/raffle'
import RaffleBtn from './business/raffleBtn'
import SurveyForm from './business/surveyForm'
import SurveyBtn from './business/surveyBtn'
import GoodsTips from './business/goodsTips'
import DoubleFacedImage from './business/doubleFacedImage'
import TreasureBtn from './business/treasureBtn'
import WorldCupBtn from './business/worldCupBtn'

const _xy_register_components_object = {}
const components = [
  Text,
  Image,
  Tinymce,
  Qrcode,
  Input,
  Svga,
  VerticalLayout,
  HorizontalLayout,
  AbsoluteLayout,
  FixedLayout,
  Dialog,
  CountDown,
  ListItemLayout,
  LuckyWheel,
  LuckyGrid,
  LuckyGridTwo,
  LuckyBtn,
  ActivityMarquee,
  Progress,
  WaveProgress,
  Stepper,
  Raffle,
  Swiper,
  SurveyForm,
  SurveyBtn,
  GoodsTips,
  RaffleBtn,
  DoubleFacedImage,
  TreasureBtn,
  WorldCupBtn
]

// 定义 install 方法，接收 Vue 作为参数
const install = function (Vue) {
  // 判断是否安装，安装过就不继续往下执行
  if (install.installed) return
  install.installed = true
  // 遍历注册所有组件
  components.map((component) => {
    Vue.component(component.name, component)
    _xy_register_components_object[component.name] = component
  })
  console.log('组件注册完成', _xy_register_components_object)
}

export default {
  install,
  _xy_register_components_object
}
